import { render, staticRenderFns } from "./MedicalInsuranceLevelBtns.vue?vue&type=template&id=34e96e66&"
import script from "./MedicalInsuranceLevelBtns.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports